module.exports = __webpack_public_path__ + "static/media/Cube4_in.1ffe2f07.jpg";